export enum AnnuityPensionAnnuityTypeIdEnum {
  LifeOnly = 1,
  RefundLife = 2,
  JointLastSurvivorSixty = 3,
  JointLastSurvivorSeventyFive = 4,
  JointLastSurvivorOneHundred = 5
}
